import React from 'react';

const GameControls = ({ gameState, onStart, onResume, onReset }) => {
  const getStartButtonText = () => {
    switch (gameState) {
      case 'playing':
        return 'GAME RUNNING...';
      case 'paused':
        return 'RESUME';
      default:
        return 'START GAME';
    }
  };

  const handleStartClick = () => {
    if (gameState === 'paused') {
      onResume();
    } else {
      onStart();
    }
  };

  const isStartDisabled = gameState === 'playing';

  return (
    <div className="game-controls">
      <button 
        className="btn btn-primary" 
        onClick={handleStartClick}
        disabled={isStartDisabled}
        data-state={gameState}
      >
        {getStartButtonText()}
      </button>
      <button 
        className="btn btn-secondary" 
        onClick={onReset}
      >
        RESET
      </button>
    </div>
  );
};

export default GameControls;
